// extracted by mini-css-extract-plugin
export default {"tableLocalFiltersContainer":"tableLocalFilters_tableLocalFiltersContainer__QEymx","selectWrapper":"tableLocalFilters_selectWrapper__YiiZt","title":"tableLocalFilters_title__JL451"};